/**
 *  Estimates the bedrag (`IngediendBedrag`) for a verantwoording row that
 *  hasn't been turned into a declaratieregel yet, used only for the TR369
 *  budget-warning estimate in `DeclaratieButtons.tsx` (the real amount is
 *  computed server-side once the declaratie is actually generated).
 *
 *  Ported from `back-end/back-end/app/route/invoices/addInvoices.ts`'s
 *  `calculateStatementAmount` - keep both in sync, this repo has no shared
 *  package between front-end and back-end.
 *
 *  When `eenheid` is `'83'` (euro's/eurocenten), the iStandaarden spec (CS339)
 *  requires `IngediendBedrag` to equal `GeleverdVolume` exactly - `volume`
 *  already *is* the amount, so the normal tarief/tarief_deler math is skipped.
 *
 *  Simplification vs. the backend original: doesn't special-case credit rows
 *  (`previeus_declaratieregel_id` set, amount = `-previous_totaal`) - the
 *  unprocessed-list query doesn't expose `previous_totaal` client-side, and
 *  this is only used for a non-blocking budget warning.
 */
export default function calculateStatementAmount(row: {
	volume: number,
	tarief: number | null,
	tarief_deler: number | null,
	eenheid: string,
}): number {
	if (row.eenheid === '83') {
		return row.volume;
	}
	const tarief = row.tarief ?? 0;
	const tarief_deler = row.tarief_deler ?? 1;
	return Math.round((row.volume * (tarief === 0 ? 1 : tarief)) / tarief_deler);
}
